var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(_vm._s(_vm.format ? _vm.$moment(_vm.date).format(_vm.format) : _vm.$moment(_vm.date).from()))])
}
var staticRenderFns = []

export { render, staticRenderFns }